exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".priority-tag{white-space:normal}.priority-tag i{font-size:17.35px;line-height:.38em;vertical-align:top;width:.4em}.priority-tag em,.priority-tag i{display:inline-block;font-style:normal}.priority-tag .priority-0,.priority-tag em{color:#ececec}.priority-tag .priority-1 .on{color:#75a628}.priority-tag .priority-2 .on{color:#ff925e}.priority-tag .priority-3 .on{color:#e02630}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a3fab85","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_modules/Payment/components/PaymentPriorityTag.vue
// module id = K3ov
// module chunks = 12